"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  gradient,
  ...props
}) => {
  const iconSharedUtils = require('./utils/icon-shared-utils');
  const hasGradient = iconSharedUtils.hasValidGradient(gradient);
  let fillValue = color;
  let gradientDefs;
  let gradientUtils;
  if (hasGradient) {
    gradientUtils = iconSharedUtils.getGradientUtils();
    const iconWebUtils = require('./utils/icon-web-utils');
    const gradientId = gradientUtils.generateGradientId(gradient);
    fillValue = `url(#${gradientId})`;
    gradientDefs = iconWebUtils.renderWebGradientDefs(gradient, gradientId);
  }
  const svgContent = (0, _jsxRuntime.jsxs)("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    fill: fillValue,
    role: title ? 'img' : undefined,
    "aria-hidden": !title,
    "aria-labelledby": titleId,
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      id: titleId,
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      d: "M4.302 5h5.883a.488.488 0 0 1 .087.969l-.087.007H4.302a.325.325 0 0 0-.319.26l-.007.066v13.396c0 .158.112.289.26.319l.066.006h13.396a.325.325 0 0 0 .319-.26l.006-.065V13.62a.488.488 0 0 1 .97-.088l.007.088v6.078c0 .673-.513 1.229-1.169 1.295l-.133.007H4.302a1.303 1.303 0 0 1-1.295-1.169L3 19.698V6.302c0-.673.513-1.228 1.169-1.295L4.302 5h5.883-5.883Zm8.458-2h7.734a.508.508 0 0 1 .468.314l.003.019a.572.572 0 0 1 .03.112l.005.06v7.736a.505.505 0 0 1-1 .091l-.009-.09V4.72L9.861 14.852a.503.503 0 0 1-.772-.643l.06-.07 10.127-10.13H12.76a.504.504 0 0 1-.091-1l.09-.009h7.735-7.734Z",
      clipRule: "evenodd"
    })]
  });
  return hasGradient ? gradientUtils.addGradientToSvg(svgContent, gradientDefs) : svgContent;
};